import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { Observable, map } from 'rxjs';

export interface AllGroups {
	permission?: string;
	distinguishedName?: string;
	usertype?: string;
	description?: string;
	customer?: number;
	full_name?: string;
	email?: string;
	sort_order?: number;
	group?: number;
	toggle?: boolean;
}

@Injectable({
	providedIn: 'root',
})
export class AccessSettingsService {
	private getAllEndusersGroupsURL = environment.baseApiUrl + 'enduser/groups/{group_name}';
	private getSearchPermissionsURL = environment.baseApiUrl + 'enduser/searchPermissions';
	private getSearchUsertypeURL = environment.baseApiUrl + 'enduser/searchUsertype';
	private updatePermissionOrderURL = environment.baseApiUrl + 'enduser/updatePermissionOrder';
	private postPermissionAnalystURL = environment.baseApiUrl + 'enduser/createPermissionAnalyst';
	private deleteUsertypeURL = environment.baseApiUrl + 'enduser/deleteUsertype/{usertype}';
	private managePermissionGroupURL = environment.baseApiUrl + 'enduser/managePermissionGroup';

	constructor(
		private httpClient: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllEndusersGroups(groupNameEndusers: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getAllEndusersGroupsURL = this.getAllEndusersGroupsURL.replace('{group_name}', groupNameEndusers);
		return this.httpClient.get<JSON[]>(getAllEndusersGroupsURL, { headers: headers }).pipe(
			map((enduser) => {
				const body: AllGroups[] = [];
				enduser.forEach((infoEnduser: any) => {
					const infoEndusers: AllGroups = {
						full_name: infoEnduser.full_name,
						email: infoEnduser.email,
					};

					body.push(infoEndusers);
				});
				return body;
			})
		);
	}

	getSearchPermissions(usertype?: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const getAllEndusersGroupsURL =
			usertype === '' ? this.getSearchPermissionsURL : `${this.getSearchPermissionsURL}?usertype=${usertype}`;
		return this.httpClient.get<any[]>(getAllEndusersGroupsURL, { headers: headers }).pipe(
			map((group) => {
				const body: AllGroups[] = [];
				group.forEach((infoGroup: any) => {
					const infoGroups: AllGroups = {
						permission: infoGroup.permission,
						description: infoGroup.description,
						usertype: infoGroup.usertype,
						group: infoGroup.group,
						toggle: infoGroup.usertype === '' ? false : true,
					};

					body.push(infoGroups);
				});

				return body;
			})
		);
	}

	getSearchUsertype(): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		return this.httpClient.get<any[]>(this.getSearchUsertypeURL, { headers: headers }).pipe(
			map((group) => {
				const body: AllGroups[] = [];
				group.forEach((infoGroup: any) => {
					const infoGroups: AllGroups = {
						customer: infoGroup.customer,
						distinguishedName: infoGroup.distinguishedName,
						usertype: infoGroup.usertype,
					};

					body.push(infoGroups);
				});

				return body;
			})
		);
	}

	managePermissionGroup(usertype: string, permissions: any[]): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			usertype: usertype,
			permissions: permissions,
		};

		return this.httpClient.post(this.managePermissionGroupURL, body, { headers: headers });
	}

	postUsertype(value: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = {
			usertype: value,
		};

		return this.httpClient.post(this.postPermissionAnalystURL, body, { headers: headers });
	}

	updatePermissionOrder(payload: any[]): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const body = payload;

		return this.httpClient.put<any[]>(this.updatePermissionOrderURL, body, { headers: headers });
	}

	deleteUsertype(usertype: string): Observable<any> {
		const headers = new HttpHeaders({
			Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
			'Content-Type': 'application/json;charset=UTF-8',
		});
		const deleteUsertypeURL = this.deleteUsertypeURL.replace('{usertype}', usertype);

		return this.httpClient.delete<string>(deleteUsertypeURL, { headers: headers });
	}
}
